import { IonButton, IonInput, IonItem } from '@ionic/react';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NormalText, StrongText, SmallText, Spacer, Title } from '../../components/common';
import Mobiscroll from '../../components/mobiscroll';
import Basket from '../../lib/basket';
import moment from '../../lib/moment';
import { withTranslation } from '../../lib/translate';
import { isEmptyObject } from '../../lib/utils';
import Layout from '../../components/layout';
import { withRouter } from 'react-router';
import Loading from '../../components/spinner';
import './index.css';
import api from '../../lib/api';
import { getConfig } from '../../appConfig.js';
import { ReactComponent as VoucherID } from '../../assets/images/voucher-id.svg';
import { ReactComponent as VoucherCode } from '../../assets/images/voucher-code.svg';
import { ReactComponent as VoucherExpiry } from '../../assets/images/voucher-expiry.svg';
import BlockSeparator from '../../components/blockSeparator';


class GiftBalance extends Component {
	constructor(props) {
		super(props);
		this.state = {
			voucherId: '',
			voucherCode: '',
			voucherBalance: null,
		};
	}
	componentDidMount() { }
	checkBalance = async () => {
		try {
			const { voucherCode, voucherId } = this.state;
			const voucher = await api.checkGiftVoucherBalance({ ...(voucherCode && { voucher_code: voucherCode }), ...(voucherId && { voucher_id: voucherId }) });
			this.setState({ voucherBalance: voucher.data });
		} catch (err) {
			this.setState({ voucherBalance: { error: true, message: err.response?.data?.error?.message } });
		}
	};
	handleInput = (field, value) => {
		this.setState((prev) => ({ [field]: value, ...(prev.voucherBalance?.error && { voucherBalance: null }) }));
	};
	render() {
		const { __ } = this.props;
		const { voucherBalance } = this.state;
		const { removeVoucherNumberFromGiftCardClaim, removeRedemptionCodeFromGiftCardClaim } = getConfig().flags;
		return (
			<Loading transparent>
				<Layout showHamburger headerWithTitle title={__('Check balance')} hideSecondToolbar={true} color="transparent" scrollY={false} backHandler={this.backHandler}>
					<div className="absolute-content scrollable-y box-with-shadow">
						<Title className="web-only page-title-centered">{__('Check balance')}</Title>

						<NormalText className="block page-title-centered">{__('If your voucher does not include a security code, please check in-store')}</NormalText>
						<Spacer size={5} />
						{!removeVoucherNumberFromGiftCardClaim && (
							<div className="input-field-container">
								<StrongText>{__('Voucher number')}</StrongText>
								<IonItem lines="none" className="input-field-wrapper">
									<IonInput
										placeholder={__('e.g. 40021880')}
										type="text"
										inputmode="numeric"
										pattern="[0-9]*"
										onIonInput={(e) => {
											const voucherId = (e.target.value || '').replace(/[^0-9]/g, '');
											e.target.value = voucherId;
											this.handleInput('voucherId', voucherId);
										}}
										value={this.state.voucherId}
									></IonInput>
								</IonItem>
							</div>
						)}
						{!removeRedemptionCodeFromGiftCardClaim && (
							<div className="input-field-container">
								<StrongText>{__('Redemption code')}</StrongText>
								<IonItem lines="none" className="input-field-wrapper">
									<IonInput
										placeholder={__('e.g. FRYUP')}
										type="text"
										inputmode="text"
										autocapitalize="characters"
										onIonInput={(e) => {
											const voucherCode = (e.target.value || '').toUpperCase();
											e.target.value = voucherCode;
											this.handleInput('voucherCode', voucherCode);
										}}
										value={this.state.voucherCode}
									></IonInput>
								</IonItem>
							</div>
						)}
						{!isEmptyObject(voucherBalance) && (
							<>
									<div className={`box-content vocher-balance-result ${voucherBalance.error ? 'vocher-balance-result-error' : ''}`}>
										{voucherBalance.error ? (
										<>
												{voucherBalance.message ? (
													<StrongText className='text-to-update'>{__(voucherBalance.message)}</StrongText>
												) : (
													<>
														<StrongText className='text-to-update'>{__('Gift voucher not found')}</StrongText>
														<Spacer size={1} />
														<SmallText className='text-to-update'>{__('Please check the details and try again')}</SmallText>
													</>
												)}
										</>
									) : (
										<>
												<div style={{ width: '100%' }}>
													<div style={{ padding: 'var(--ion-padding)' }} className='gift-balance-summary'>
											
														<StrongText className="block">{`${Basket.formatPrice(voucherBalance?.points_value / 100)} ${__('eGift Voucher')}`} </StrongText>
														<Spacer size={3} />
														{/* The number the customer entered: the Square gift card number on Square clients
														    (a card sold at a till has no voucher id at all), the voucher id elsewhere. A card
														    with no security code or no expiry date leaves those rows out. */}
														{!removeVoucherNumberFromGiftCardClaim && voucherBalance?.gift_card_number && (
														<>
															<div>
																<VoucherID />
																<StrongText>{__('Voucher ID:')}</StrongText>
																<NormalText className='label-color'>{voucherBalance?.gift_card_number}</NormalText>
															</div>
															<Spacer size={1} />
														</>
													)}
													{!removeRedemptionCodeFromGiftCardClaim && voucherBalance?.redeem_code && (
														<>
															<div>
																<VoucherCode />
																<StrongText>{__('Security code:')}</StrongText>
																<NormalText className='label-color'>{voucherBalance?.redeem_code}</NormalText>
															</div>
															<Spacer size={1} />
														</>
													)}
													{voucherBalance?.expiry_date && (
														<>
															<div>
																<VoucherExpiry />
																<StrongText>{__('Expiry date:')}</StrongText>
																<NormalText className='label-color'>{moment(voucherBalance?.expiry_date)?.format('LLLL')}</NormalText>
															</div>
															<Spacer size={1} />
														</>
													)}
												</div>

												<BlockSeparator fullWidth />
												<div style={{ padding: 'var(--ion-padding)' }}>
													<StrongText className="block">{__('Remaining balance:')}</StrongText>
													<Spacer size={1} />
													<NormalText className='label-color'>{Basket.formatPrice(voucherBalance?.value_remaining / 100)}</NormalText>
												</div>

											</div>

										</>
									)}
								</div>
								<Spacer size={5} />

							</>
						)}

						{!voucherBalance?.error && (
							<IonButton className='button-uppercase' disabled={(!removeVoucherNumberFromGiftCardClaim && this.state.voucherId == '') || (!removeRedemptionCodeFromGiftCardClaim && this.state.voucherCode == '')} onClick={() => this.checkBalance()} expand="block" color="primary">
								{__('Check balance')}
							</IonButton>
						)}
					</div>
				</Layout>
			</Loading>
		);
	}
}

const stateToProps = (state) => {
	return {};
};

export default withRouter(withTranslation(connect(stateToProps)(GiftBalance)));
